import { authData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    authData
  }
};
